import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, forwardRef, Input, Output, EventEmitter, ViewChild, ElementRef,} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable, map, startWith } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteComponent),
      multi: true
    }
  ]
})
export class AutocompleteComponent implements ControlValueAccessor {
  @Input() optionsDictionnary: any[] | undefined;
  @Input() placeholder: string| undefined;
  @Input() displayProperty: string | null = '';
  @Input() valueProperty: string| null = '';
  @Output() optionSelected = new EventEmitter<any>();
  @Output() optionRemoved = new EventEmitter<any>();

  @ViewChild('autoP', {static: false}) matAutocomplete: any;
  @ViewChild('optionInput', { static: false }) optionInput!: ElementRef<HTMLInputElement>;

  optionCtrl: FormControl = new FormControl();

  filteredOptions: Observable<any[]> | undefined;
  selectedOptions: any[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];

  propagateChange = (_: any) => {};
  propagateTouched = () => {};

  ngOnInit(): void {
    this.filteredOptions = this.optionCtrl.valueChanges.pipe(
      startWith(null),
      map(value => typeof value === 'object' && value !== null ? this._filter(value.group) : this._filter(value))
    );
  }

  writeValue(value: any): void {
    console.log(' on write value ', value);
    if (value !== undefined) {
      console.log('set selectedOptions ', value)
      this.selectedOptions = JSON.parse(JSON.stringify(value));

      this.propagateChange(this.selectedOptions);
  }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouched = fn;
  }

  private _filter(value: string): any[] {
    if (!value || !this.optionsDictionnary) return [];

    const filterValue = value.toLowerCase();

    return this.optionsDictionnary.filter(option =>
      this.valueProperty && this.valueProperty != '' ? option[this.valueProperty || 0].toLowerCase().includes(filterValue)
                                                     : option && option.toLowerCase().includes(filterValue));
  }

  addOption(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen && this.optionsDictionnary) {
      const input = event.input;
      const value = event.value.trim();
      const option = this.optionsDictionnary.find(item => item.name.toUpperCase() === value.toUpperCase());

      if (option && !this.selectedOptions.includes(option)){
        this.selectedOptions.push(option);
        this.propagateChange(this.selectedOptions);
        this.optionSelected.emit(option);
      }

      if (input) {
        input.value = '';
      }
    }
  }

  selectedOption(event: MatAutocompleteSelectedEvent): void {
    if(!this.optionsDictionnary){
        this.optionInput.nativeElement.value = '';
        this.optionCtrl.setValue(null);
        return;
    }

    const option = this.optionsDictionnary.find(item => item.name === event.option.viewValue);

    if (option && !this.selectedOptions.includes(option)){
      // Manually append the new option to the list of selected optionsDictionnary
    this.selectedOptions.push(option);

    // Now propagate the change
    this.propagateChange([...this.selectedOptions]);
      this.optionSelected.emit(option);
    }

    this.optionInput.nativeElement.value = '';
    this.optionCtrl.setValue(null);
  }

  removeOption(option: any) {
    const index = this.selectedOptions.indexOf(option);
    if (index >= 0) {
      this.selectedOptions.splice(index, 1);
      this.propagateChange(this.selectedOptions);
      this.optionRemoved.emit(option);
    }
  }
}
